import { Field, FieldProps } from 'formik';
import { FormattedMessage } from 'react-intl';
import { Grid } from '@mui/material';
import { PoolSelect, PoolTextField, PoolTypography, SelectOption } from '@synergy/components';
import { PortalVisibility, UsageType } from '@synergy/models';

export const AddressAdditionalInfo = () => {
    const usageTypeOptions: SelectOption[] = [
        {
            value: UsageType.Address,
            displayValue: <FormattedMessage id="app.select.option.deliveryAddress" />,
        },
        {
            value: UsageType.Invoice,
            displayValue: <FormattedMessage id="app.select.option.invoiceAddress" />,
        },
        {
            value: UsageType.Both,
            displayValue: <FormattedMessage id="app.select.option.invoiceAndDeliveryAddress" />,
        },
    ];

    const visibilityOptions: SelectOption[] = [
        {
            value: PortalVisibility.Shop,
            displayValue: <FormattedMessage id="app.select.option.shop" />,
        },
        {
            value: PortalVisibility.Synergy,
            displayValue: <FormattedMessage id="app.select.option.synergy" />,
        },
        {
            value: PortalVisibility.Both,
            displayValue: <FormattedMessage id="app.select.option.shopAndSynergy" />,
        },
    ];

    return (
        <Grid container={true} item={true} spacing={2}>
            <Grid item={true} xs={12}>
                <PoolTypography
                    styleType="sectionTitle"
                    id="app.contactsAndOrganizations.detail.additionalInformation"
                />
            </Grid>
            <Grid item={true} xs={12}>
                <Field name="usageType">
                    {({ field, form }: FieldProps<UsageType>) => (
                        <PoolSelect
                            fullWidth={true}
                            label={<FormattedMessage id="app.label.usage" />}
                            options={usageTypeOptions}
                            disallowDefaultValue={true}
                            onValueChange={value => form.setFieldValue(field.name, value)}
                            value={field.value}
                            name={field.name}
                            noSorting={true}
                        />
                    )}
                </Field>
            </Grid>
            <Grid item={true} xs={6}>
                <Field name="visibility">
                    {({ field, form }: FieldProps<PortalVisibility>) => (
                        <PoolSelect
                            fullWidth={true}
                            label={<FormattedMessage id="app.label.visibility" />}
                            options={visibilityOptions}
                            disallowDefaultValue={true}
                            onValueChange={value => form.setFieldValue(field.name, value)}
                            value={field.value}
                            name={field.name}
                            noSorting={true}
                        />
                    )}
                </Field>
            </Grid>
            <Grid item={true} xs={6}>
                <Field name="costCentre">
                    {({ field, meta }: FieldProps<PortalVisibility>) => (
                        <PoolTextField
                            fullWidth={true}
                            label={<FormattedMessage id="app.label.costCentre" />}
                            error={!!meta.touched && !!meta.error}
                            helperText={meta.touched && meta.error ? <FormattedMessage id={meta.error} /> : null}
                            {...field}
                        />
                    )}
                </Field>
            </Grid>
        </Grid>
    );
};
